import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { localhostGuard } from './guards/localhost.guard';

export const appRoutes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth/auth-routing.module').then(m => m.AuthRoutingModule),
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('./pages/pages-routing.module').then(m => m.PagesRoutingModule),
    canActivate: [authGuard],
  },
  {
    path: 'component-docs',
    loadChildren: () =>
      import('./components/documentation/component-documentation-routing.module').then(
        m => m.ComponentDocumentationRoutingModule
      ),
    canActivate: [localhostGuard],
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(
        m => m.NotFoundComponent
      ),
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./pages/unauthorized/unauthorized.component').then(
        m => m.UnauthorizedComponent
      ),
  },
  {
    path: 'quotation',
    loadChildren: () =>
      import('./pages/quotation/quotation-routing.module').then(
        m => m.QuotationRoutingModule
      ),
  },
  {
    path: 'report',
    loadChildren: () =>
      import('./pages/public-report/public-report-routing.module').then(
        m => m.PublicReportRoutingModule
      ),
  },
  {
    path: 'upgrade',
    loadComponent: () =>
      import('./pages/upgrade-feature-plan/upgrade-feature-plan.component').then(
        m => m.UpgradeFeaturePlanComponent
      ),
  },
  {
    path: 'integrations/btg/callback',
    loadComponent: () =>
      import('./pages/integrations/btg/btg-callback.component').then(
        m => m.BtgCallbackComponent
      ),
  },
  {
    path: 'cadastro/:token',
    loadComponent: () =>
      import('./pages/producer-registration/producer-registration.component').then(
        m => m.ProducerRegistrationComponent
      ),
  },
  {
    path: 'ponto',
    loadComponent: () =>
      import('./pages/worker-portal/worker-portal.component').then(
        m => m.WorkerPortalComponent
      ),
  },
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];
